import React from 'react';
import AffiliateList from '../components/affiliate/AffiliateList';
import { getActiveAffiliates } from '../view/HTTPService';

/**
 * /activeAffiliates - Lista de afiliados ATIVOS.
 */
export default function ActiveAffiliatesPage() {
    return (
        <AffiliateList
            titleKey="msg.jkaActiveAffiliates"
            fetchAffiliates={getActiveAffiliates}
        />
    );
}
